import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { navSelector } from '../../../store/js/modules/competition-nav/selectors/nav-selector';
import { FixturesNav } from './FixturesNav';
import { FixturesList } from './fixtures-list/FixturesList';
import { FixturesSkeleton } from './fixtures-list/FixturesSkeleton';

export const Fixtures = (data) => {
    const nav = useSelector(navSelector);

    return (
        <>
            <FixturesNav {...data} />

            <div className="wrapper widget">
                {!nav.competition.id ||
                !nav.season.id ||
                !nav.round.roundNumber ? (
                    <FixturesSkeleton />
                ) : (
                    <FixturesList {...data} />
                )}
            </div>
        </>
    );
};

Fixtures.propTypes = {
    data: PropTypes.object
};
